import { useQuery } from '@tanstack/react-query'
import { Row, Col, Card, Statistic, Spin } from 'antd'
import {
  UserOutlined,
  AppstoreOutlined,
  TeamOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons'
import { getStats } from '../api/admin'

const Dashboard = () => {
  const { data: statsData, isLoading } = useQuery({
    queryKey: ['stats'],
    queryFn: () => getStats().then((res) => res.data.data),
  })

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '100px' }}>
        <Spin size="large" />
      </div>
    )
  }

  const stats = statsData || {
    accounts: { total: 0, active: 0, pending: 0, verified: 0 },
    apps: { total: 0, active: 0 },
    users: { total: 0, active: 0 },
  }

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>平台概览</h2>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="总账户数"
              value={stats.accounts.total}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="已验证账户"
              value={stats.accounts.verified}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="应用数量"
              value={stats.apps.total}
              prefix={<AppstoreOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="用户映射数"
              value={stats.users.total}
              prefix={<TeamOutlined />}
              valueStyle={{ color: '#fa8c16' }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card title="账户状态分布">
            <Row gutter={16}>
              <Col span={8}>
                <Statistic title="活跃" value={stats.accounts.active} />
              </Col>
              <Col span={8}>
                <Statistic title="待验证" value={stats.accounts.pending} />
              </Col>
              <Col span={8}>
                <Statistic title="已验证" value={stats.accounts.verified} />
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="应用状态">
            <Row gutter={16}>
              <Col span={12}>
                <Statistic title="总应用" value={stats.apps.total} />
              </Col>
              <Col span={12}>
                <Statistic title="活跃应用" value={stats.apps.active} />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default Dashboard
